import { useEffect, useState } from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { dashboardService } from "@/services";
import { KpiCard } from "@/components/widgets/KpiCard";
import { ChartWidget } from "@/components/widgets/ChartWidget";
import { AlertWidget } from "@/components/widgets/AlertWidget";
import { TableWidget } from "@/components/widgets/TableWidget";
import { Loader2 } from "lucide-react";

const RENDERERS = { kpi: KpiCard, chart: ChartWidget, alert: AlertWidget, table: TableWidget, list: TableWidget };

export default function DashboardPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dashboardService.me().then(setData).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-20 text-muted-foreground" data-testid="dashboard-loading">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  const widgets = data?.widgets || [];
  const kpis = widgets.filter((w) => w.type === "kpi");
  const rest = widgets.filter((w) => w.type !== "kpi");

  return (
    <div data-testid="dashboard-page">
      <PageHeader title={data?.dashboard?.name || "Dashboard"} subtitle="Role-based platform overview" />
      {widgets.length === 0 ? (
        <div className="bg-card rounded-xl border border-border p-12 text-center text-muted-foreground">
          No dashboard configured for your role.
        </div>
      ) : (
        <>
          {kpis.length > 0 && (
            <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-7">
              {kpis.map((w) => <KpiCard key={w.widgetKey} widget={w} />)}
            </div>
          )}
          <div className="grid lg:grid-cols-2 gap-6">
            {rest.map((w) => {
              const Comp = RENDERERS[w.type] || TableWidget;
              return <Comp key={w.widgetKey} widget={w} />;
            })}
          </div>
        </>
      )}
    </div>
  );
}
